<template>
  <div class="app-form">
    <div class="app-form__wrappper">
      <form class="app-form__form" v-on="$listeners" v-bind="$attrs">
        <slot />
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppForm',
  inheritAttrs: false,

  props: {
    callback: {
      type: Function,
      default: () => {},
    },
  },
}
</script>

<style scoped></style>
